import { render } from "./Ann.vue?vue&type=template&id=db542fbe&scoped=true&ts=true"
import script from "./Ann.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ann.vue?vue&type=script&setup=true&lang=ts"

import "./Ann.vue?vue&type=style&index=0&id=db542fbe&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db542fbe"],['__file',"src/components/home/Ann.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db542fbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db542fbe', __exports__)) {
    console.log('reload')
    api.reload('db542fbe', __exports__)
  }
  
  module.hot.accept("./Ann.vue?vue&type=template&id=db542fbe&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('db542fbe', render)
  })

}


export default __exports__